<template>
  <b-modal
    lazy
    size="xl"
    class="v3_modal"
    ok-variant="v3_teal_outline"
    ok-title="Submit ICO"
    cancel-variant="v3_red_outline"
    :visible="visible"
    footer-class="border_0 justify-content-start footer_post_to_exchange"
    @ok="$emit('ok')"
    @cancel="$emit('cancel')"
    no-close-on-backdrop
    no-close-on-esc
  >
    <template slot="modal-header-close">
      <span>Close window</span>
      <i class="mdi mdi-close-circle-outline" />
    </template>
    <div
      class="font_size_1000rem font_weight_bold v3_color_black_knight"
    >
      Confirm Post to Exchange
    </div>
<!--    <b-row v-if="sanitizedContent" class="mt-4">-->
<!--      <b-col v-html="sanitizedContent" />-->
<!--    </b-row>-->

        <b-row class="mt-4">
          <b-col>
            <p>Click Submit ICO to post {{ title }} to the Connect exchange.</p>
          </b-col>
        </b-row>
  </b-modal>
</template>

<script>
import Api from '@/providers/Api';
import sanitizeHtml from "sanitize-html";

export default {
  name: 'PostToExchangeModal',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    }
  },
  data: function () {
    return {
      contentData: null,
    };
  },
  created: function() {
    this.loadContent();
  },
  computed: {
    contentLoaderName: function () {
      return this.$options.name + '_contentLoading';
    },
    sanitizedContent: function () {
      return this.contentData && this.contentData.content ? sanitizeHtml(this.contentData.content) : null;
    },
  },
  methods: {
    loadContent: async function () {
      this.$wait.start(this.contentLoaderName);
      try {
        this.contentData = await Api.getIcoPostInfo1Content();
      } catch {
        this.$toasted.error(
          'Unable to update page content. Please try again later',
          { duration: 3000 }
        );
      } finally {
        this.$wait.end(this.contentLoaderName);
      }
    },
  },
};
</script>

<style lang="scss" >
  .footer_post_to_exchange {
    padding-left: 4.5rem !important;
    padding-bottom: 3rem !important;
  }
</style>
